import React from "react";
import { Box, styled } from "@mui/material";
import { keyframes } from "@mui/material/styles";
import { COLORS } from "../constants/pipes";

// Animation keyframes
const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

// Styled components
const EndpointIndicator = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  backgroundColor: "#FF6B6B",
  boxShadow: "0 0 8px rgba(255, 107, 107, 0.5)",
  zIndex: 1,
}));

const EndpointContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&::before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    border: "2px solid #FF6B6B",
    borderRadius: "4px",
    animation: `${pulse} 2s infinite`,
  },
}));

const PipeSegment = ({
  type,
  rotation,
  isEndpoint,
  hasJunction,
  row,
  col,
  isLocked,
  getPipeImage,
}) => {
  return (
    <Box
      data-row={row}
      data-col={col}
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        transform: `rotate(${rotation}deg)`,
        transition: "transform 0.2s ease-out",
        transformOrigin: "center",
        cursor: isLocked ? "not-allowed" : "pointer",
        opacity: isLocked ? 0.8 : 1,
      }}
    >
      {isEndpoint ? (
        <EndpointContainer>
          <Box
            component="img"
            src={getPipeImage(type)}
            alt={`${type} pipe`}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              filter: "brightness(0.9) contrast(1.2)",
              zIndex: 2,
            }}
          />
          <EndpointIndicator />
        </EndpointContainer>
      ) : (
        <Box
          component="img"
          src={getPipeImage(type)}
          alt={`${type} pipe`}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      )}
      {hasJunction && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "10px",
            height: "10px",
            backgroundColor: COLORS.pipe.junction,
            borderRadius: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: "0 0 4px rgba(255, 0, 0, 0.5)",
          }}
        />
      )}
    </Box>
  );
};

export default PipeSegment;
